import { render, staticRenderFns } from "./CertifikatiPredelava.vue?vue&type=template&id=9d30c4a2&"
import script from "./CertifikatiPredelava.vue?vue&type=script&lang=js&"
export * from "./CertifikatiPredelava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports